import React, { type FunctionComponent, useEffect } from 'react'
import { injectIntl } from 'react-intl'
import { type InjectedDashIntlProps } from 'intl/intl.types'
import { useTrackEvent } from 'utils/events/hooks'
import { StoreGroupsAddContent } from 'legacy/sections/store-groups/components/add/StoreGroupsAddContent'
import { useGoToStoreGroupsList } from 'legacy/sections/store-groups/utils/navigation.hooks'
import { useCreateStoreGroupOnSubmit } from 'legacy/sections/store-groups/components/add/utils/submitForm'
import { useNotifications } from 'legacy/common/utils/notifications/notifications.hooks'
import { type RetailerRouteComponentProps } from 'legacy/components/RetailerRoute'

interface Props extends InjectedDashIntlProps, RetailerRouteComponentProps {}

const _StoreGroupsAdd: FunctionComponent<Props> = ({ intl }) => {
  useTrackEvent({
    id: 'settings.store_groups.add.viewed',
    description: 'Viewed the store groups add page',
  })

  const goToStoreGroupsList = useGoToStoreGroupsList()
  const { handleSubmit, createdStoreGroup, error } = useCreateStoreGroupOnSubmit()
  const { notify, notifyError } = useNotifications()

  // Redirect back to the store groups list page after creation
  useEffect(() => {
    if (!createdStoreGroup) return

    notify(
      intl.formatMessage(
        { id: 'settings.storeGroups.notifications.createSuccess' },
        { name: createdStoreGroup.name }
      )
    )
    goToStoreGroupsList()
  }, [createdStoreGroup, goToStoreGroupsList, intl, notify])

  // Redirect back to the store groups list page after error
  useEffect(() => {
    if (!error) return

    notifyError(intl.formatMessage({ id: 'settings.storeGroups.notifications.createError' }))
    goToStoreGroupsList()
  }, [error, goToStoreGroupsList, intl, notifyError])

  return <StoreGroupsAddContent handleSubmit={handleSubmit} />
}

export const StoreGroupsAdd = injectIntl(_StoreGroupsAdd)
